<template>
    <table class="table-light" v-if="data">
        <thead>
            <td>Время</td>
            <td>Тип</td>
            <td>Номер букинга</td>
            <td>Статус</td>
        </thead>
        <tr v-for="(item, index) in data" :key="index">
            <td>
                <div class="range _wide">
                    <p>{{ item.time_start }}</p>
                    <span>&ndash;</span>
                    <p>{{ item.time_end }}</p>
                    <span>&ndash;</span>
                    {{ item.length }} мин
                </div>
            </td>
            <td>{{ item.car_type }}</td>
            <td><router-link class="link2" :to="'/booking/' + item.id">{{ item.number }}</router-link></td>
            <td>{{ item.checkin_status }}</td>
        </tr>
    </table>
</template>

<script>
    export default {
        props: ['data']
    }
</script>